<template>
  <div class="side-panel">
    <h1>Les deux minutes du peuple</h1>
    <p>de <a href="https://fr.wikipedia.org/wiki/Fran%C3%A7ois_P%C3%A9russe" target="_blank">François Pérusse</a></p>

    <p>
      Tu es sur un lecteur web <em>non-officiel</em> de deux minutes du peuple. Pour soutenir directement l'artiste, il y a :
    </p>
    <ul>
      <li><a href="http://francoisperusse.ca/" target="_blank">Son site officiel</a></li>
      <li><a href="https://www.youtube.com/user/LeFrancoisPerusse" target="_blank">Sa chaîne Youtube</a></li>
      <li><a href="https://www.facebook.com/francois.perusse" target="_blank">Son facebook</a></li>
      <li><a href="https://twitter.com/Franpeuple" target="_blank">Son oaseau</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'side-panel'
}
</script>

<style scoped lang="scss">

h1 {
  font-size: 1.8em;
}

p {
  margin: 5px 0 10px 0;
}

em {
  font-style: italic;
}

a {
  color: $white-tr;
  &:hover {
    color: $white;
  }
}

li {
  list-style: square;
  margin-left: 15px;
}

.side-panel {
  position: fixed;
  background-color: $darkerviolet;
  color: $white;

  padding: 15px;
  margin: 15px;
  border-radius: 5px;
  width: 500px;
  max-width: calc(((100vw - 500px) / 2) - 40px);
}

@media all and (max-width: 1000px) {
  .side-panel {
    display: none;
  }
}
</style>
